import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import { Tabs, Tab } from "@mui/material";
import DurgsProduct from "./DurgsProduct";
import OTCProduct from "./OTCProduct";
import { useLocation, useNavigate } from "react-router-dom";

const Partners = () => {
  const [tabIndex, setTabIndex] = useState(0);
  const location = useLocation();
  const navigate = useNavigate();
  
  const searchParams = new URLSearchParams(location.search);
  const type = searchParams.get("type");
  console.log(type);

  useEffect(() => {
    if (!type) {
      // ✅ If no query param, default to DURGS
      navigate("?type=durgs", { replace: true });
    } else if (type === "durgs") {
      setTabIndex(0);
    } else if (type === "otc") {
      setTabIndex(1);
    }
  }, [type, navigate]);

  const handleChange = (event, newValue) => {
    setTabIndex(newValue);
    const queryType = newValue === 0 ? "durgs" : "otc";
    navigate(`?type=${queryType}`);
  };

  return (
    <div>
      {/* Tabs Header */}
      <Box sx={{ width: "100%", mt: 7 }}>
        <Tabs
          value={tabIndex}
          onChange={handleChange}
          variant="fullWidth"
          TabIndicatorProps={{ style: { display: "none" } }}
          sx={{
            backgroundColor: "rgba(255, 255, 255, 0.8)",
            backdropFilter: "blur(10px)",
            borderRadius: "16px",
            padding: "8px",
            boxShadow: "0 8px 32px rgba(0, 0, 0, 0.08)",
            border: "1px solid rgba(255, 255, 255, 0.2)",
            "& .MuiTabs-flexContainer": {
              gap: "8px",
            },
          }}
        >
          <Tab
            label="Drugs"
            sx={{
              textTransform: "none",
              fontWeight: 600,
              fontSize: "15px",
              borderRadius: "12px",
              padding: "16px 24px",
              background: "linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)",
              color: "#64748b",
              border: "1px solid rgba(226, 232, 240, 0.6)",
              transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
              position: "relative",
              overflow: "hidden",
              "&:hover": {
                transform: "translateY(-2px)",
                boxShadow: "0 12px 24px rgba(0, 0, 0, 0.1)",
                background: "linear-gradient(135deg, #ffffff 0%, #f1f5f9 100%)",
              },
              "&.Mui-selected": {
                background: "linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)",
                color: "#ffffff",
                boxShadow: "0 12px 32px rgba(59, 130, 246, 0.4)",
                transform: "translateY(-3px)",
                border: "1px solid rgba(59, 130, 246, 0.3)",
                "&::after": {
                  content: '""',
                  position: "absolute",
                  bottom: "6px",
                  left: "50%",
                  transform: "translateX(-50%)",
                  width: "24px",
                  height: "3px",
                  backgroundColor: "#ffffff",
                  borderRadius: "2px",
                  opacity: 0.8,
                },
              },
            }}
          />
          <Tab
            label="OTC Products"
            sx={{
              textTransform: "none",
              fontWeight: 600,
              fontSize: "15px",
              borderRadius: "12px",
              padding: "16px 24px",
              background: "linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)",
              color: "#64748b",
              border: "1px solid rgba(226, 232, 240, 0.6)",
              transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
              position: "relative",
              overflow: "hidden",
              "&:hover": {
                transform: "translateY(-2px)",
                boxShadow: "0 12px 24px rgba(0, 0, 0, 0.1)",
                background: "linear-gradient(135deg, #ffffff 0%, #f1f5f9 100%)",
              },
              "&.Mui-selected": {
                background: "linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)",
                color: "#ffffff",
                boxShadow: "0 12px 32px rgba(59, 130, 246, 0.4)",
                transform: "translateY(-3px)",
                border: "1px solid rgba(59, 130, 246, 0.3)",
                "&::after": {
                  content: '""',
                  position: "absolute",
                  bottom: "6px",
                  left: "50%",
                  transform: "translateX(-50%)",
                  width: "24px",
                  height: "3px",
                  backgroundColor: "#ffffff",
                  borderRadius: "2px",
                  opacity: 0.8,
                },
              },
            }}
          />
        </Tabs>

        {/* Tab Content */}
        <Box
          sx={{
            p: 4,
            mt: 3,
            background: "linear-gradient(145deg, #ffffff 0%, #f8fafc 100%)",
            borderRadius: "20px",
            boxShadow: "0 20px 60px rgba(0, 0, 0, 0.08)",
            border: "1px solid rgba(226, 232, 240, 0.3)",
            position: "relative",
            overflow: "hidden",
            "&::before": {
              content: '""',
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              height: "4px",
              background: "linear-gradient(90deg, #3b82f6, #8b5cf6, #06b6d4)",
              borderRadius: "20px 20px 0 0",
            },
          }}
        >
          <Box
            sx={{
              transition: "all 0.4s ease-in-out",
              opacity: 1,
              transform: "translateY(0)",
            }}
          >
            {tabIndex === 0 && <DurgsProduct type={type} />}
            {tabIndex === 1 && <OTCProduct type={type}/>}
          </Box>
        </Box>
      </Box>
    </div>
  );
};

export default Partners;
